"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const steps = [{
  title: "Audit",
  description: "Systematic analysis of your lead flow to identify critical revenue leaks and missed opportunities."
}, {
  title: "Build",
  description: "Precision engineering of AI Voice agents and CRM-integrated recovery systems built for industrial scale."
}, {
  title: "Inject",
  description: "Seamless deployment of the Revenue Recovery Engine into your core operations and existing workflows."
}, {
  title: "Optimize",
  description: "Rigorous monitoring and pressure testing to maintain peak operational efficiency and zero lead loss."
}];
export default function FromLogicToLaunch() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="128863" id="integration-process" className="dark bg-background text-foreground relative py-24 md:py-32 overflow-hidden" ref={ref}>
      {}
      <div className="absolute inset-0 opacity-[0.06] pointer-events-none" style={{
      backgroundImage: "linear-gradient(to right, var(--color-primary) 1px, transparent 1px), linear-gradient(to bottom, var(--color-primary) 1px, transparent 1px)",
      backgroundSize: "80px 80px",
      maskImage: "radial-gradient(ellipse 80% 50% at 50% 50%, black 40%, transparent 100%)",
      WebkitMaskImage: "radial-gradient(ellipse 80% 50% at 50% 50%, black 40%, transparent 100%)"
    }} />

      <div className="container mx-auto px-4 relative z-10 max-w-6xl">
        <div className={`text-center mb-16 md:mb-24 transition-all duration-700 transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-3xl md:text-6xl font-serif font-black uppercase tracking-tighter mb-4">
            The Blueprint of Excellence
          </h2>
          <p className="text-muted-foreground font-sans max-w-2xl mx-auto text-lg md:text-xl border-t border-primary/20 pt-4">
            Our high-precision pipeline for repairing revenue leaks and scaling operations.
          </p>
        </div>

        {}
        <div className="hidden md:grid grid-cols-4 gap-4 relative">
          {}
          <div className={`absolute top-[50%] left-0 w-full h-1 bg-primary/30 -translate-y-1/2 transition-all duration-1000 delay-300 ${isVisible ? "scale-x-100 opacity-100" : "scale-x-0 opacity-0"} origin-left shadow-[0_0_10px_rgba(181,166,66,0.2)]`} />

          {steps.map((step, i) => <div key={i} data-index={i} className={`group flex flex-col items-center justify-between h-72 relative z-10 transition-all duration-700 transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`} style={{
          transitionDelay: `${400 + i * 150}ms`
        }}>
              {}
              <div className="flex-1 flex items-end pb-8 w-full justify-center">
                <h3 className="text-xl font-serif font-bold uppercase text-foreground/70 group-hover:text-primary transition-colors duration-300 tracking-wider">
                  {step.title}
                </h3>
              </div>

              {}
              <div className="relative flex items-center justify-center w-8 h-8">
                <div className="absolute w-4 h-4 rounded-none bg-background border-2 border-primary rotate-45 transition-all duration-500 group-hover:scale-[1.5] group-hover:bg-primary group-hover:shadow-[0_0_25px_var(--color-primary)] z-10" />
                {}
                <div className="absolute w-full h-full rounded-full bg-primary/0 group-hover:bg-primary/30 group-hover:animate-ping transition-all duration-500" />
              </div>

              {}
              <div className="flex-1 pt-8 px-4 text-center w-full">
                <p className="text-sm font-sans text-muted-foreground group-hover:text-foreground transition-colors duration-300 leading-relaxed max-w-[200px] mx-auto">
                  {step.description}
                </p>
              </div>
            </div>)}
        </div>

        {}
        <div className="md:hidden flex flex-col gap-12 relative pl-6 mt-12">
          {}
          <div className={`absolute top-2 bottom-2 left-[11px] w-[3px] bg-primary/30 transition-all duration-1000 delay-300 ${isVisible ? "scale-y-100 opacity-100" : "scale-y-0 opacity-0"} origin-top`} />

          {steps.map((step, i) => <div key={i} data-index={i} className={`group relative z-10 transition-all duration-700 transform ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"}`} style={{
          transitionDelay: `${400 + i * 150}ms`
        }}>
              {}
              <div className="absolute -left-[32px] top-1.5 w-4 h-4 rounded-none bg-background border-2 border-primary rotate-45 transition-all duration-500 group-hover:scale-[1.5] group-hover:bg-primary group-hover:shadow-[0_0_20px_var(--color-primary)]" />
              
              <h3 className="text-xl font-serif font-bold uppercase text-foreground/80 group-hover:text-primary transition-colors duration-300 mb-3 tracking-wide">
                {step.title}
              </h3>
              <p className="text-sm font-sans text-muted-foreground group-hover:text-foreground transition-colors duration-300 leading-relaxed">
                {step.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}